










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';


@Component({})
export default class BaseCard extends Vue {
    @Prop() size!: [string, string];
}
